function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire489c"];
parcelRequire.register("5bRq1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a65400bc0cee08ef$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $99w1R = parcelRequire("99w1R");

var $bh6RR = parcelRequire("bh6RR");

var $kvjXY = parcelRequire("kvjXY");

var $6Aslh = parcelRequire("6Aslh");
const $a65400bc0cee08ef$var$PersistLogin = ()=>{
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(true);
    const { userData: userData , setUserData: setUserData  } = (0, $6Aslh.default)();
    (0, $bh6RR.useEffect)(()=>{
        const verifyRefreshToken = async ()=>{
            try {
                await (0, $kvjXY.default).get("/core_api/user-data", {
                    withCredentials: true
                }).then((response)=>{
                    if (response.status == 200) setUserData({
                        ...response.data,
                        isLoggedIn: true,
                        subscriptionStatus: {
                            enabled: response.data.user_plan.name == "subscription",
                            endDate: response.data.user_plan.subscription_renewal_date,
                            isCanceled: response.data.user_plan.subscription_cancelled
                        },
                        isLegacyUser: response.data.legacy_user
                    });
                });
            } catch (error) {
                console.error(error);
            } finally{
                setIsLoading(false);
            }
        };
        !userData?.isLoggedIn ? verifyRefreshToken() : setIsLoading(false);
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            children: "Loading..."
        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Outlet), {})
    });
};
var $a65400bc0cee08ef$export$2e2bcd8739ae039 = $a65400bc0cee08ef$var$PersistLogin;

});


//# sourceMappingURL=PersistLogin.4391f411.js.map
